<script lang="ts">
    import { tick } from "svelte";

    export let text = ""
    let className
    export {className as class}

    let inputText = text
    let editing = false
    let textInput: HTMLInputElement

    const updateInputText = () => inputText = text
    $: text, updateInputText()

    function handleEnter(event: KeyboardEvent) {
        if (event.key == 'Enter') {
            text = inputText
            editing = false
        }
    }

    function selectText() {
        textInput.focus()
        textInput.select()
    }
</script>

<div class={className}>
{#if !editing}
<div class="flex items-center gap-1">
    {text}
    <button class="btn-xfai-icon border-none bg-transparent hover:bg-xerteal-50 text-xerteal-700" 
        on:click={async () => {
            editing = true
            await tick()
            selectText()
        }}
    >
        <i class="fa-light fa-edit"/>
    </button>
</div>

{:else}
<div class="flex items-baseline font-normal text-base">
    <input bind:this={textInput} bind:value={inputText} class="input-xfai mr-1" type="text" on:keydown={handleEnter}/>
    <button class="btn-xfai-icon border-none bg-transparent hover:bg-xerteal-50 text-xerteal-700" type="button" 
        on:click={() => {
            text = inputText
            editing = false
        }}
    > 
        <i class="fa-regular fa-check"/>
    </button>
    <button class="btn-xfai-icon border-none bg-transparent hover:bg-xerteal-50 text-xerteal-700" type="button" 
        on:click={() => {
            editing = false
        }}
    > 
        <i class="fa-regular fa-x"/>
    </button>
</div>
{/if}
</div>

